import { HoldingMethod } from './HoldingMethod';

export enum FiscalAccountType {
  PEA = HoldingMethod.PEA,
  PEA_PME = HoldingMethod.PEA_PME,
}
